import { actionNameGenerator } from "../../../../utils/commonUtil";

const domainPrefix = "iod";
const iodActionNameGenerator = actionNameGenerator(domainPrefix);

export const drupalFailedType = iodActionNameGenerator("drupalFailed");;
export const fetchInvestmentOptionDataType = iodActionNameGenerator("fetchInvestmentOptionData");;
export const fetchUnderlyingTableDataType = iodActionNameGenerator("fetchUnderlyingTableData");
export const fetchUnderlyingTableDataSuccessType = iodActionNameGenerator("fetchUnderlyingTableDataSuccess")
export const fetchUnderlyingTableDataFailureType = iodActionNameGenerator("fetchUnderlyingTableDataFailure")
export const investmentOptionUstDataType = iodActionNameGenerator("investmentOptionUstData");
export const investmentOptionUstDataLoaderType = iodActionNameGenerator("investmentOptionUstDataLoader");
export const investmentOptionDrupalType = iodActionNameGenerator("investmentOptionDrupal")
export const investmentOptionDrupalDataType = iodActionNameGenerator("investmentOptionDrupalData")
export const investmentOptionDrupalDataLoaderType = iodActionNameGenerator("investmentOptionDrupalDataLoader")
export const myInvestmentOptionUstDataType = iodActionNameGenerator("myInvestmentOptionUstData");
export const myInvestmentOptionUstFailedType = iodActionNameGenerator("myInvestmentOptionUstFailed");
export const myInvestmentOptionUstDataLoaderType = iodActionNameGenerator("myInvestmentOptionUstDataLoader")
export const processedDataType = iodActionNameGenerator("processedData");
export const quaterlyReportDrupalDataType = iodActionNameGenerator("quaterlyReportDrupalData")
export const quaterlyReportDrupalDataLoaderType = iodActionNameGenerator("quaterlyReportDrupalDataLoader")
export const quaterlyReportFailedType = iodActionNameGenerator("quaterlyReportFailed")
export const underlyingOptionDrupalDataType = iodActionNameGenerator("underlyingOptionDrupalData")
export const underlyingOptionDrupalDataLoaderType = iodActionNameGenerator("underlyingOptionDrupalDataLoader")
export const underlyingFailedType = iodActionNameGenerator("underlyingFailed")
export const ustFailedType = iodActionNameGenerator("ustFailed")
